/**
 * Work: one section, two ways to look at the same work.
 *
 * Projects and Board were siblings in the sidebar, which asked the customer to
 * understand that they are two renderings of one reality before they had seen
 * either. They are now one destination with a view switch - the list is the
 * default because it is the shape Alan approved (Uber "your trips"), and the
 * board is there for people who think in columns.
 *
 * The Trello column names are NOT touched. Whatever the board syncs is what it
 * shows; renaming client-side would invent a vocabulary nobody else uses.
 *
 * @module web/screens/app/WorkSection
 */
import type { WorkView } from "../../routes.ts";
import { ProjectsScreen } from "./ProjectsScreen.tsx";
import { BoardScreen } from "./board/BoardScreen.tsx";

export function WorkSection({ view, onView, card = null }: {
  view: WorkView;
  onView: (v: WorkView) => void;
  /** `#work/board/<cardId>`: open the board with this card's panel open. */
  card?: string | null;
}) {
  return (
    <>
      <div className="seg-bar fade-in">
        <div className="seg" role="tablist" aria-label="View">
          <button
            role="tab"
            aria-selected={view === "list"}
            className={`seg-btn${view === "list" ? " on" : ""}`}
            onClick={() => onView("list")}
          >
            List
          </button>
          <button
            role="tab"
            aria-selected={view === "board"}
            className={`seg-btn${view === "board" ? " on" : ""}`}
            onClick={() => onView("board")}
          >
            Board
          </button>
        </div>
      </div>

      {view === "board" ? <BoardScreen initialCardId={card} /> : <ProjectsScreen />}
    </>
  );
}
